import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextM, TextS } from 'frontend/js/modules/infra/dls/components/typography';
import styles from '../styles.module.scss';
export var CampaignNameAndDescription = function (_a) {
    var name = _a.name, description = _a.description;
    return (_jsxs("div", { className: styles.multiline, children: [_jsx(TextM, { color: "primary", className: "".concat(styles.header, " ").concat(styles['campaign-name']), children: name }), _jsx(TextS, { color: "secondary", children: description })] }));
};
